<app-live-class-header *ngIf="isShowHeader" [isRecordingClass]="isRecordingClass"></app-live-class-header>
<router-outlet></router-outlet>